const Mock = require('mockjs');
// 获取 mock.Random 对象
const Random = Mock.Random;

const produceArticle = function() {
  let article = {
    title: '用户协议',
    sections: []
  }
  for (let i = 0; i < 20; i++) {
    article.sections.push(Random.csentence(10, 250))
  }

  return {
    "code": 0,
    "message": 'success',
    article
  }
}

export default {
  getArticle: config => {
    return produceArticle()
  }
}



// WEBPACK FOOTER //
// ./src/mock/agreement.js